import {Component, inject, signal, ChangeDetectionStrategy} from '@angular/core';
import { environment } from '../../../../environments/environment';
import {SystemParamsService} from "../../services/system-params-service/system-params.service";
import {NgOptimizedImage} from "@angular/common";

@Component({
    selector: 'app-footer',
  imports: [
    NgOptimizedImage
  ],
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './footer.component.css'
})
export class FooterComponent {
  systemParamsService = inject(SystemParamsService);
  environment = signal(environment.stage);
}
